var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-launch"},[(_vm.listLength >= 5)?_c('div',{staticClass:"btn-more-launch",on:{"click":_vm.showFiveMoreContent}},[_vm._v(_vm._s(_vm.$t('view_more')))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }